const bestOffers = [
  {
    group_name: "Pertamina",
    recommended: [
      {
        product: "Investment Credit",
        features: {
          reason_code: "",
          desc: "Medium or long-term loans to complete your company’s investments.",
          lists: [
            {
              label: "Product Features",
              items: [
                "It can be utilized for the purchase of capital goods and services which are required to establish new projects, current project expansions,modernization, rehabilitation, project relocations or refinancing goods that have been paid for in advance.",
                "The credit time limit can be adjusted according to the business ability ofthe customer.",
                "Competitive interest rates.",
                "Credit liquidation advantages and other transactions, supported by Bank’s nation wide network.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
      {
        product: "Working Capital Loan",
        features: {
          reason_code: "",
          desc: "Capital loans that can improve your business.",
          lists: [
            {
              label: "Product Features",
              items: [
                "Applicable for a variety of needs, such as a Working Capital Loan forindustry, transportation, hospitality, construction, etc.",
                "Competitive interest rates.",
                "Ease of credit disbursement and other transactions supported by Bank networks available throughout Indonesia.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
    ],
  },
  {
    group_name: "Garudafood",
    recommended: [
      {
        product: "Investment Credit",
        features: {
          reason_code: "",
          desc: "Medium or long-term loans to complete your company’s investments.",
          lists: [
            {
              label: "Product Features",
              items: [
                "It can be utilized for the purchase of capital goods and services which are required to establish new projects, current project expansions,modernization, rehabilitation, project relocations or refinancing goods that have been paid for in advance.",
                "The credit time limit can be adjusted according to the business ability ofthe customer.",
                "Competitive interest rates.",
                "Credit liquidation advantages and other transactions, supported by Bank’s nation wide network.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
      {
        product: "Working Capital Loan",
        features: {
          reason_code: "",
          desc: "Capital loans that can improve your business.",
          lists: [
            {
              label: "Product Features",
              items: [
                "Applicable for a variety of needs, such as a Working Capital Loan forindustry, transportation, hospitality, construction, etc.",
                "Competitive interest rates.",
                "Ease of credit disbursement and other transactions supported by Bank networks available throughout Indonesia.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
    ],
  },
  {
    group_name: "Semen", //client_id
    recommended: [
      {
        product: "Investment Credit",
        features: {
          reason_code: "",
          desc: "Medium or long-term loans to complete your company’s investments.",
          lists: [
            {
              label: "Product Features",
              items: [
                "It can be utilized for the purchase of capital goods and services which are required to establish new projects, current project expansions,modernization, rehabilitation, project relocations or refinancing goods that have been paid for in advance.",
                "The credit time limit can be adjusted according to the business ability ofthe customer.",
                "Competitive interest rates.",
                "Credit liquidation advantages and other transactions, supported by Bank’s nation wide network.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
      {
        product: "Working Capital Loan",
        features: {
          reason_code: "",
          desc: "Capital loans that can improve your business.",
          lists: [
            {
              label: "Product Features",
              items: [
                "Applicable for a variety of needs, such as a Working Capital Loan forindustry, transportation, hospitality, construction, etc.",
                "Competitive interest rates.",
                "Ease of credit disbursement and other transactions supported by Bank networks available throughout Indonesia.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
    ],
  },
  {
    group_name: "PLN",
    recommended: [
      {
        product: "Investment Credit",
        features: {
          reason_code: "",
          desc: "Medium or long-term loans to complete your company’s investments.",
          lists: [
            {
              label: "Product Features",
              items: [
                "It can be utilized for the purchase of capital goods and services which are required to establish new projects, current project expansions,modernization, rehabilitation, project relocations or refinancing goods that have been paid for in advance.",
                "The credit time limit can be adjusted according to the business ability ofthe customer.",
                "Competitive interest rates.",
                "Credit liquidation advantages and other transactions, supported by Bank’s nation wide network.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
      {
        product: "Working Capital Loan",
        features: {
          reason_code: "",
          desc: "Capital loans that can improve your business.",
          lists: [
            {
              label: "Product Features",
              items: [
                "Applicable for a variety of needs, such as a Working Capital Loan forindustry, transportation, hospitality, construction, etc.",
                "Competitive interest rates.",
                "Ease of credit disbursement and other transactions supported by Bank networks available throughout Indonesia.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
    ],
  },
  {
    group_name: "United Tractor",
    recommended: [
      {
        product: "Investment Credit",
        features: {
          reason_code: "",
          desc: "Medium or long-term loans to complete your company’s investments.",
          lists: [
            {
              label: "Product Features",
              items: [
                "It can be utilized for the purchase of capital goods and services which are required to establish new projects, current project expansions,modernization, rehabilitation, project relocations or refinancing goods that have been paid for in advance.",
                "The credit time limit can be adjusted according to the business ability ofthe customer.",
                "Competitive interest rates.",
                "Credit liquidation advantages and other transactions, supported by Bank’s nation wide network.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
      {
        product: "Working Capital Loan",
        features: {
          reason_code: "",
          desc: "Capital loans that can improve your business.",
          lists: [
            {
              label: "Product Features",
              items: [
                "Applicable for a variety of needs, such as a Working Capital Loan forindustry, transportation, hospitality, construction, etc.",
                "Competitive interest rates.",
                "Ease of credit disbursement and other transactions supported by Bank networks available throughout Indonesia.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
    ],
  },
  {
    group_name: "Pupuk",
    recommended: [
      {
        product: "Investment Credit",
        features: {
          reason_code: "",
          desc: "Medium or long-term loans to complete your company’s investments.",
          lists: [
            {
              label: "Product Features",
              items: [
                "It can be utilized for the purchase of capital goods and services which are required to establish new projects, current project expansions,modernization, rehabilitation, project relocations or refinancing goods that have been paid for in advance.",
                "The credit time limit can be adjusted according to the business ability ofthe customer.",
                "Competitive interest rates.",
                "Credit liquidation advantages and other transactions, supported by Bank’s nation wide network.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
      {
        product: "Working Capital Loan",
        features: {
          reason_code: "",
          desc: "Capital loans that can improve your business.",
          lists: [
            {
              label: "Product Features",
              items: [
                "Applicable for a variety of needs, such as a Working Capital Loan forindustry, transportation, hospitality, construction, etc.",
                "Competitive interest rates.",
                "Ease of credit disbursement and other transactions supported by Bank networks available throughout Indonesia.",
              ],
            },
            {
              label: "Special Rate",
              items: ["Not Applicable"],
            },
          ],
        },
      },
    ],
  },
];

export default bestOffers;
